/** 同意書フォーム — 印字対象（患者情報） */
export const PRINT_COL_OPTIONS = [
  { label: '住所', value: 'patient_address' },
  { label: '氏名', value: 'patient_name' },
  { label: '受診者生年月日', value: 'patient_birth_of_date' },
] as const;

export const ALL_PRINT_COL_VALUES = PRINT_COL_OPTIONS.map(o => o.value);

/** 同意書フォーム — ラベル印字トグル対象キー（画面共通） */
export const CONSENT_FORM_COMMON_LABEL_KEYS = [
  'incident_date',
  'is_continuation',
  'examine_date',
  'disease_name',
  'remarks',
  'hospital_name',
  'doctor_name',
  'hospital_postal_code',
  'hospital_address',
  'consent_date',
  'walking_condition_id',
] as const;

/** 発病・負傷年月日 — 入力タイプ */
export const INCIDENT_DATE_TYPE_OPTIONS = [
  { label: 'その他（不詳）', value: 1 },
  { label: '年指定', value: 2 },
  { label: '月指定', value: 3 },
  { label: '日付指定', value: 4 },
] as const;

export const INCIDENT_DATE_TYPE_ID = {
  UNKNOWN: 1,
  YEAR: 2,
  MONTH: 3,
  DATE: 4,
} as const;

/** 業務上・外、第三者行為の有無 */
export const INCIDENT_TYPE_OPTIONS = [
  { label: 'その他', value: 1 },
  { label: '業務上', value: 2 },
  { label: '第３者行為である', value: 3 },
] as const;

export const INCIDENT_TYPE_ID = {
  OTHER: 1,
  WORK: 2,
  THIRD_PARTY: 3,
} as const;

/** A2 — 傷病名② */
export const A2_DISEASE_OTHER_ID = '7';

export const A2_DISEASE_NAME_OPTIONS = [
  { label: '神経痛', value: '1' },
  { label: 'リウマチ', value: '2' },
  { label: '頚腕症候群', value: '3' },
  { label: '五十肩', value: '4' },
  { label: '腰痛症', value: '5' },
  { label: '頸椎捻挫後遺症', value: '6' },
  { label: 'その他', value: A2_DISEASE_OTHER_ID },
] as const;

/** A2 — 施術内容 */
export const A2_TREATMENT_CONTENT_OPTIONS = [
  { label: 'はり', value: 'はり' },
  { label: '電気針', value: '電気針' },
  { label: 'きゅう', value: 'きゅう' },
  { label: '電気温灸', value: '電気温灸' },
  { label: '電気光線器', value: '電気光線器' },
] as const;

/** 往療 */
export const WALKING_CONDITION_OPTIONS = [
  { label: '必要とする', value: 1 },
  { label: '必要としない', value: 2 },
] as const;

export const WALKING_CONDITION_ID = {
  REQUIRED: 1,
  NOT_REQUIRED: 2,
} as const;

/** 往療を必要とする理由 — その他 (`walking_condition_reason_types.id` = 3) */
export const WALKING_CONDITION_REASON_OTHER_ID = '3';

/** 往療を必要とする理由 — values are the master ids, exactly as legacy a2/r2 stored them */
export const WALKING_CONDITION_REASON_TYPE_OPTIONS = [
  { label: '独歩による公共交通機関を使っての外出が困難', value: '1' },
  { label: '認知症や視覚、内部、精神障害などにより単独での外出が困難', value: '2' },
  { label: 'その他', value: WALKING_CONDITION_REASON_OTHER_ID },
] as const;

/** R2 — 症状・施術部位（spec R2 §14–15） */
export const R2_SYMPTOM_MUSCLE_OPTIONS = [
  { label: '右上肢', value: '右上肢' },
  { label: '左上肢', value: '左上肢' },
  { label: '右下肢', value: '右下肢' },
  { label: '左下肢', value: '左下肢' },
  { label: '躯幹', value: '躯幹' },
] as const;

export const R2_SYMPTOM_JOINT_OPTIONS = [
  { label: '右肩', value: '右肩' },
  { label: '右肘', value: '右肘' },
  { label: '右手首', value: '右手首' },
  { label: '右股関節', value: '右股関節' },
  { label: '右膝', value: '右膝' },
  { label: '右足首', value: '右足首' },
  { label: '左肩', value: '左肩' },
  { label: '左肘', value: '左肘' },
  { label: '左手首', value: '左手首' },
  { label: '左股関節', value: '左股関節' },
  { label: '左膝', value: '左膝' },
  { label: '左足首', value: '左足首' },
  { label: 'その他', value: 'その他' },
] as const;

/**
 * r_symptom_joints.id → r_symptom_muscles.id (body region)
 * Mirrors legacy R2 RConsentController::getConsentDifferent mapping.
 */
export const R2_JOINT_TO_BODY_REGION: Record<string, string> = {
  '1': '1', '2': '1', '3': '1',      // 右肩,右肘,右手首 → 右上肢
  '4': '3', '5': '3', '6': '3',      // 右股関節,右膝,右足首 → 右下肢
  '7': '2', '8': '2', '9': '2',      // 左肩,左肘,左手首 → 左上肢
  '10': '4', '11': '4', '12': '4',   // 左股関節,左膝,左足首 → 左下肢
};

export const R2_SYMPTOM_JOINT_OTHER_ID = '13';

/** 関節拘縮で「その他」にチェック時、symptom_joint_other 未入力 — BD 検証メッセージ（Zod と同一文言） */
export const R2_SYMPTOM_JOINT_OTHER_REQUIRED_MESSAGE =
  'その他にチェックを入れている場合は理由を入力して下さい。';

export const R2_MASSAGE_PART_OPTIONS = [
  { label: '躯幹', value: '躯幹' },
  { label: '右上肢', value: '右上肢' },
  { label: '左上肢', value: '左上肢' },
  { label: '右下肢', value: '右下肢' },
  { label: '左下肢', value: '左下肢' },
] as const;

export const R2_ORTHOMORPHIA_PART_OPTIONS = [
  { label: '右上肢', value: '右上肢' },
  { label: '左上肢', value: '左上肢' },
  { label: '右下肢', value: '右下肢' },
  { label: '左下肢', value: '左下肢' },
] as const;

export const R2_HOT_TREATMENT_OPTIONS = [
  { label: '温罨法', value: 1 },
  { label: '温罨法・電療', value: 2 },
] as const;

export const R2_HOT_TREATMENT_TYPE_ID = {
  HOT_COMPRESS: 1,
  HOT_COMPRESS_ELECTRO: 2,
} as const;

/** 同意書削除 — toast / API 失敗時フォールバック（一覧・編集・mutation 共通） */
export const CONSENT_DELETE_SUCCESS_MESSAGE = '削除が正常に終了しました。';
export const CONSENT_DELETE_ERROR_FALLBACK = '削除ができませんでした。';

/** API が message を返す場合はそれを優先、なければ共通成功文 */
export function consentDeleteSuccessToastMessage(_apiMessage: string | null | undefined): string {
  return CONSENT_DELETE_SUCCESS_MESSAGE;
}
